export const tagsAlocacao = {
  titulo: 'Tags de alocação',
  descricao: 'Cadastro das tags que os gestores atribuem às alocações.',
  nova: 'Nova tag',
  total_one: 'Mostrando {{showing}} de {{count}} tag',
  total_other: 'Mostrando {{showing}} de {{count}} tags',
  colunas: {
    nome: 'Nome',
    cor: 'Cor',
    ativa: 'Ativa',
    alocacoes: 'Alocações vinculadas',
  },
  filtros: {
    avancadosDescricao:
      'Os campos acompanham as colunas visíveis da tabela: mostre ou esconda colunas em "Colunas" para mudar os filtros disponíveis.',
    corPlaceholder: 'Ex.: #00BCD4',
  },
  tabela: {
    acoesDaTag: 'Ações da tag {{nome}}',
    vazioTitulo: 'Nenhuma tag cadastrada',
    vazioDescricao: 'Cadastre a primeira para os gestores poderem marcar as alocações.',
    filtroSemResultadoTitulo: 'Nenhuma tag com esses filtros',
    filtroSemResultadoDescricao: 'Ajuste ou limpe os filtros para ver as tags.',
  },
  acoes: {
    editar: 'Editar',
    excluir: 'Excluir',
  },
  form: {
    tituloNova: 'Nova tag de alocação',
    tituloEditar: 'Editar tag de alocação',
    nome: 'Nome',
    cor: 'Cor',
    corSeletor: 'Escolher a cor',
    corDica: 'Hexadecimal, ex.: #00BCD4.',
    ativa: 'Ativa',
    ativaDica:
      'Tag inativa não é oferecida em novas alocações nem nos filtros, mas continua nas alocações que já a têm.',
    previa: 'Prévia',
    emUso_one: 'Vinculada a {{count}} alocação.',
    emUso_other: 'Vinculada a {{count}} alocações.',
    criar: 'Criar tag',
  },
  validacao: {
    nomeMaximo: 'Use até {{max}} caracteres.',
    corInvalida: 'Use o formato #RRGGBB.',
  },
  excluir: {
    titulo: 'Excluir a tag "{{nome}}"?',
    descricao:
      'Nenhuma alocação usa esta tag, então ela será excluída de vez. Essa ação não pode ser desfeita.',
    emUso:
      'Esta tag está vinculada a alocações e não pode ser excluída. Para tirá-la de uso, edite e desative.',
    confirmar: 'Excluir tag',
  },
  toasts: {
    criarSucesso: 'Tag criada.',
    atualizarSucesso: 'Tag atualizada.',
    excluirSucesso: 'Tag excluída.',
  },
  exportacao: {
    titulo: 'Exportar tags',
    todasPaginas_one: 'Todas as páginas ({{count}} tag)',
    todasPaginas_other: 'Todas as páginas ({{count}} tags)',
    paginaAtual_one: 'Só esta página ({{count}} tag)',
    paginaAtual_other: 'Só esta página ({{count}} tags)',
    nomeArquivo: 'tags-alocacao',
  },
} as const;
